import styled from 'styled-components';

export const StyledBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 1rem 0;
`;
